module.exports = __webpack_public_path__ + "img/banner1_1.fab72ae6.png";